<!-- splash screen -->
<div #splashScreen class="splash-screen">
	<img [src]="logoSrc" alt="Logo" />
	<strong>Loading ...</strong>
</div>